export const categories = [
  { id: "city-tour", label: "City Tour" },
  { id: "adventure", label: "Adventure Tour" },
];

export const products = {
  "city-tour": [
    { id: "city-bike", name: "City Bike Tour", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: false },
  ],
  adventure: [
    { id: "hiking", name: "Mountain Hiking", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: false },
  ],
};